var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60958 1.33343L1.33343 3.60958L0.390625 2.66677L2.66677 0.390625L3.60958 1.33343Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 0.390625L15.6096 2.66677L14.6668 3.60958L12.3906 1.33343L13.3334 0.390625Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9429 6.66677L7.33343 10.2762L5.05729 8.0001L6.0001 7.05729L7.33343 8.39062L10.0001 5.72396L10.9429 6.66677Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33343 8.0001C1.33343 4.3182 4.3182 1.33343 8.0001 1.33343C11.682 1.33343 14.6668 4.3182 14.6668 8.0001C14.6668 11.682 11.682 14.6668 8.0001 14.6668C4.3182 14.6668 1.33343 11.682 1.33343 8.0001ZM8.0001 2.66677C5.05458 2.66677 2.66677 5.05458 2.66677 8.0001C2.66677 10.9456 5.05458 13.3334 8.0001 13.3334C10.9456 13.3334 13.3334 10.9456 13.3334 8.0001C13.3334 5.05458 10.9456 2.66677 8.0001 2.66677Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCheck);
export default __webpack_public_path__ + "static/media/clock-check.6b7c9278701f8c22aab7b4c015e4d6e6.svg";
export { ForwardRef as ReactComponent };